import api from '../_api'
import { service as hyperCommonService } from '@/api/hyper-common'
import {
    FETCH_ALL_CONSOLIDATED_REQUEST,
    FETCH_ALL_CONSOLIDATED_SUCCESS,
    FETCH_ALL_CONSOLIDATED_FAILED,
    DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_REQUEST,
    DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_SUCCESS,
    DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_FAILED
} from './mutation-type'

const fetchAllConsolidated = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx, month, estimated }) => {
    commit(FETCH_ALL_CONSOLIDATED_REQUEST)
    try {
        const { status, data } = await api.fetchAllConsolidated({ qtype, projectIdx, groupIdx, month, estimated }, rootGetters.requiredService)
        commit(FETCH_ALL_CONSOLIDATED_SUCCESS, { status, data: data.data || {} })
        return data
    } catch (error) {
        commit(FETCH_ALL_CONSOLIDATED_FAILED, error)
        throw error
    }
}

const downloadConsolidatedAccountExcel = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx, month }) => {
    commit(DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_REQUEST)
    try {
        const { data } = await hyperCommonService.consolidatedAccountExcel({ qtype, projectIdx, groupIdx, month }, rootGetters.requiredService)
        commit(DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_SUCCESS)
        return data
    } catch (error) {
        commit(DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_FAILED, error)
        throw error
    }
}

export default {
    fetchAllConsolidated,
    downloadConsolidatedAccountExcel
}
